/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Offerhover_Publisher1Inputs */

const id_home_offerhover_publisher1 = /** @type {(inputs: Home_Offerhover_Publisher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penerbit:`)
};

const ms_home_offerhover_publisher1 = /** @type {(inputs: Home_Offerhover_Publisher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penerbit:`)
};

const da_home_offerhover_publisher1 = /** @type {(inputs: Home_Offerhover_Publisher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forlægger:`)
};

const de_home_offerhover_publisher1 = /** @type {(inputs: Home_Offerhover_Publisher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herausgeber:`)
};

const en_us2_home_offerhover_publisher1 = /** @type {(inputs: Home_Offerhover_Publisher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publisher:`)
};

const es_es2_home_offerhover_publisher1 = /** @type {(inputs: Home_Offerhover_Publisher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor:`)
};

const es_mx2_home_offerhover_publisher1 = /** @type {(inputs: Home_Offerhover_Publisher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicador:`)
};

const fil_home_offerhover_publisher1 = /** @type {(inputs: Home_Offerhover_Publisher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publisher:`)
};

const fr_home_offerhover_publisher1 = /** @type {(inputs: Home_Offerhover_Publisher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Éditeur :`)
};

const it_home_offerhover_publisher1 = /** @type {(inputs: Home_Offerhover_Publisher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editore:`)
};

const hu_home_offerhover_publisher1 = /** @type {(inputs: Home_Offerhover_Publisher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiadó:`)
};

const nl_home_offerhover_publisher1 = /** @type {(inputs: Home_Offerhover_Publisher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitgever:`)
};

const no_home_offerhover_publisher1 = /** @type {(inputs: Home_Offerhover_Publisher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utgiver:`)
};

const pl_home_offerhover_publisher1 = /** @type {(inputs: Home_Offerhover_Publisher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wydawca:`)
};

const pt_br2_home_offerhover_publisher1 = /** @type {(inputs: Home_Offerhover_Publisher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor:`)
};

const pt_home_offerhover_publisher1 = /** @type {(inputs: Home_Offerhover_Publisher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editora:`)
};

const ro_home_offerhover_publisher1 = /** @type {(inputs: Home_Offerhover_Publisher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor:`)
};

const fi_home_offerhover_publisher1 = /** @type {(inputs: Home_Offerhover_Publisher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Julkaisija:`)
};

const sv_home_offerhover_publisher1 = /** @type {(inputs: Home_Offerhover_Publisher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utgivare:`)
};

const vi_home_offerhover_publisher1 = /** @type {(inputs: Home_Offerhover_Publisher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhà xuất bản:`)
};

const tr_home_offerhover_publisher1 = /** @type {(inputs: Home_Offerhover_Publisher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yayıncı:`)
};

const cs_home_offerhover_publisher1 = /** @type {(inputs: Home_Offerhover_Publisher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vydavatel:`)
};

const bg_home_offerhover_publisher1 = /** @type {(inputs: Home_Offerhover_Publisher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Издател:`)
};

const ru_home_offerhover_publisher1 = /** @type {(inputs: Home_Offerhover_Publisher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Издатель:`)
};

const uk_home_offerhover_publisher1 = /** @type {(inputs: Home_Offerhover_Publisher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видавець:`)
};

const ar_home_offerhover_publisher1 = /** @type {(inputs: Home_Offerhover_Publisher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الناشر:`)
};

const hi_home_offerhover_publisher1 = /** @type {(inputs: Home_Offerhover_Publisher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रकाशक:`)
};

const th_home_offerhover_publisher1 = /** @type {(inputs: Home_Offerhover_Publisher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้จัดจำหน่าย:`)
};

const ja_home_offerhover_publisher1 = /** @type {(inputs: Home_Offerhover_Publisher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パブリッシャー：`)
};

const zh_cn2_home_offerhover_publisher1 = /** @type {(inputs: Home_Offerhover_Publisher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发行商:`)
};

const zh_hant1_home_offerhover_publisher1 = /** @type {(inputs: Home_Offerhover_Publisher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`發行商：`)
};

const ko_home_offerhover_publisher1 = /** @type {(inputs: Home_Offerhover_Publisher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`배급사:`)
};

/**
* | output |
* | --- |
* | "Publisher:" |
*
* @param {Home_Offerhover_Publisher1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_offerhover_publisher1 = /** @type {((inputs?: Home_Offerhover_Publisher1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Offerhover_Publisher1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_offerhover_publisher1(inputs)
	if (locale === "ms") return ms_home_offerhover_publisher1(inputs)
	if (locale === "da") return da_home_offerhover_publisher1(inputs)
	if (locale === "de") return de_home_offerhover_publisher1(inputs)
	if (locale === "en-US") return en_us2_home_offerhover_publisher1(inputs)
	if (locale === "es-ES") return es_es2_home_offerhover_publisher1(inputs)
	if (locale === "es-MX") return es_mx2_home_offerhover_publisher1(inputs)
	if (locale === "fil") return fil_home_offerhover_publisher1(inputs)
	if (locale === "fr") return fr_home_offerhover_publisher1(inputs)
	if (locale === "it") return it_home_offerhover_publisher1(inputs)
	if (locale === "hu") return hu_home_offerhover_publisher1(inputs)
	if (locale === "nl") return nl_home_offerhover_publisher1(inputs)
	if (locale === "no") return no_home_offerhover_publisher1(inputs)
	if (locale === "pl") return pl_home_offerhover_publisher1(inputs)
	if (locale === "pt-BR") return pt_br2_home_offerhover_publisher1(inputs)
	if (locale === "pt") return pt_home_offerhover_publisher1(inputs)
	if (locale === "ro") return ro_home_offerhover_publisher1(inputs)
	if (locale === "fi") return fi_home_offerhover_publisher1(inputs)
	if (locale === "sv") return sv_home_offerhover_publisher1(inputs)
	if (locale === "vi") return vi_home_offerhover_publisher1(inputs)
	if (locale === "tr") return tr_home_offerhover_publisher1(inputs)
	if (locale === "cs") return cs_home_offerhover_publisher1(inputs)
	if (locale === "bg") return bg_home_offerhover_publisher1(inputs)
	if (locale === "ru") return ru_home_offerhover_publisher1(inputs)
	if (locale === "uk") return uk_home_offerhover_publisher1(inputs)
	if (locale === "ar") return ar_home_offerhover_publisher1(inputs)
	if (locale === "hi") return hi_home_offerhover_publisher1(inputs)
	if (locale === "th") return th_home_offerhover_publisher1(inputs)
	if (locale === "ja") return ja_home_offerhover_publisher1(inputs)
	if (locale === "zh-CN") return zh_cn2_home_offerhover_publisher1(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_offerhover_publisher1(inputs)
	return ko_home_offerhover_publisher1(inputs)
});
export { home_offerhover_publisher1 as "home.offerHover.publisher" }